module.exports = __webpack_public_path__ + "img/tbaza.5245b041.png";